import { useTranslation } from "react-i18next";
import { mdiArrowTopRightThin, mdiFileDocumentMultiple } from "@mdi/js";
import Icon from "@mdi/react";
import { observer } from "mobx-react-lite";

import { NgdataIcon } from "../../assets/img/menu-icon-ngdata-colored";
import { ToolboxIcon } from "../../assets/img/menu-icon-toolbox-colored";
import { userStore } from "../../stores/userStore";
import { sendCounterEvent } from "../../utils/counterService";

const WEBGIS_DOCS_URL = {
  en: "https://docs.nextgis.com/docs_ngweb/source/",
  ru: "https://docs.nextgis.ru/docs_ngweb/source/",
};

export const WebGisLinkCards = observer(function WebGisLinkCards() {
  const { t } = useTranslation();
  const lang = userStore.isRuRegion ? "ru" : "en";
  const docsUrl = WEBGIS_DOCS_URL[lang];
  const dataUrl = `https://data.nextgis.com/login/?next=${encodeURIComponent(`/?utm_source=nextgis&utm_medium=referral&utm_campaign=mywebgis_data`)}`;
  const toolboxUrl = `https://toolbox.nextgis.com/login/?next=${encodeURIComponent(`/?utm_source=nextgis&utm_medium=referral&utm_campaign=mywebgis_toolbox`)}`;

  return (
    <>
      <a
        href={docsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="webgis-page__card webgis-page__card--link"
      >
        <h4 className="webgis-page__card-title">
          <Icon
            path={mdiFileDocumentMultiple}
            size={1}
            className="webgis-page__card-icon"
          />
          {t("webgis.docTitle")}
          <Icon
            path={mdiArrowTopRightThin}
            size={1}
            className="webgis-page__card-arrow"
          />
        </h4>
        <p className="webgis-page__card-desc">{t("webgis.docDescription")}</p>
      </a>
      <a
        href={dataUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="webgis-page__card webgis-page__card--link"
        onClick={() => sendCounterEvent("go-to-data")}
      >
        <h4 className="webgis-page__card-title">
          <NgdataIcon
            width={20}
            height={20}
            className="webgis-page__card-icon"
          />
          {t("webgis.dataTitle")}
          <Icon
            path={mdiArrowTopRightThin}
            size={1}
            className="webgis-page__card-arrow"
          />
        </h4>
        <p className="webgis-page__card-desc">{t("webgis.dataDescription")}</p>
      </a>
      <a
        href={toolboxUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="webgis-page__card webgis-page__card--link"
      >
        <h4 className="webgis-page__card-title">
          <ToolboxIcon
            width={22}
            height={18}
            className="webgis-page__card-icon"
          />
          {t("webgis.toolboxTitle")}
          <Icon
            path={mdiArrowTopRightThin}
            size={1}
            className="webgis-page__card-arrow"
          />
        </h4>
        <p className="webgis-page__card-desc">
          {t("webgis.toolboxDescription")}
        </p>
      </a>
    </>
  );
});
